
import './App.css';
import Navbar from './components/Navbar';
import Inro from './components/Inro';
import Portfolio from './components/Portfolio';
import Slider from './components/Slider';
import Apc from './components/Apc';
import Collab from './components/Collab';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link
} from "react-router-dom";
import Testimonials from './components/Testimonials';
import Upload from './components/Upload';
import * as mobilenet from '@tensorflow-models/mobilenet';
import * as tf from '@tensorflow/tfjs';
import {useState} from 'react';





function App() {

  const[s,setS]=useState("")
  const[i,seti]=useState("")



// Load the model.
const onGo=async()=>{

  const img = document.getElementById('img');
  
  
  const model = await mobilenet.load();
  
  // Classify the image.
  const predictions = await model.classify(img);
  
  
  console.log(predictions);
setS(predictions[0]['className']);
}
const handleName=async(e)=>{
const {img}=await e.target;
console.log(await e.target.files);
const url=await URL.createObjectURL(e.target.files[0]);
seti(url);
}
  return (
    
    
    <Router>

     
     <Navbar/>


     <Routes>



     <Route exact path="/upload" element={<>
     <br/>
     <br/>

     <div style={{display:'flex'}}><img id='img' crossOrigin='anonymous' width='200vw' src={i}></img>
     <h2>{s}</h2>
     </div>
       <input type="file" name="file" class="form-control"  autocomplete="off" required onChange={handleName}/>
       <br/>
       <br/>
       <div className='text-center'>

       <button type="button" class="btn btn-primary" onClick={onGo}>Predict</button>
       </div>
       </>
      } />
      {/* <Upload/> */}
      
       <Route exact path="/" element={<><Inro/>
       
       </>}/>
        
   
    

     
    
    

 

    {/* <Portfolio/>
    <br/>
    <br/upload>
    <br/>
    <br/>
    
    
    {/* <Testimonials/> */}

 
   
   
     
  
    
     
    
      


    
      {/* <Collab/> */}

  
      
      
    
      
    {/* <div  style={{display:"flex",justifyItems:"right"}}>
    <Collab/>
    
  </div> */}
   
  

       

      
      
     
 */}


  </Routes>

 
</Router>
  );
}

export default App;
